// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"a54f3b98","79":"a9566ab9","276":"5d027daa","333":"a22641de","822":"a3f42433"}[chunkId] + ".css";
};